<template>
  <div class="carousel-container" :style="isWhite ? 'width: 1198px;' : 'width: 840px;'">
    <byted-carousel arrow="hover" @change="changeImage" :autoplay="true" :loop="true" dots-type="solid"
      :dots-style="{align: 'center', dotsWidth: 38}">
      <byted-carousel-item v-for="(item, index) in slideList" :key="item.img">
        <img :src="item.img" @click="imageClick(index)">
      </byted-carousel-item>
    </byted-carousel>
  </div>
</template>

<style scoped lang="scss">
  .carousel-container {
    height: 420px;
    background: #0A2140;
    position: relative;
    .byted-carousel-item {
      img {
        width: 100%;
        height: 100%;
      }
    }
    // .text, .text1, .text2 {
    //   color: #FFF;
    //   position: absolute;
    //   top: 84px;
    //   left: 68px;
    //   span.upgrade {
    //     display: inline-block;
    //     height: 25px;
    //     font-size: 18px;
    //     font-family: PingFangSC-Regular;
    //     font-weight: 400;
    //     color: rgba(255,255,255,1);
    //     line-height: 25px;
    //     &:after {
    //       display: block;
    //       content: '';
    //       width: 37px;
    //       height: 3px;
    //       margin-top: 8px;
    //       background: #6CE1F5;
    //     }
    //   }
    //   h1 {
    //     margin-top: 35px;
    //     height: 56px;
    //     font-size: 40px;
    //     font-family: PingFangSC-Regular;
    //     font-weight: 400;
    //     color: rgba(255,255,255,1);
    //     line-height: 56px;
    //     margin-bottom: 0;
    //   }
    //   h1:nth-of-type(2) {
    //     margin-top: 4px;
    //   }
    // }
    // .text1 {
    //   left: 200px;
    // }
    // .text2 {
    //   left: 350px;
    // }
  }
  .carousel-enter-active {
    transition: all 1s ease;
  }

  .carousel-leave-active {
    transition: all 1s ease;
  }

  .carousel-enter, .carousel-leave-to {
    opacity: 0;
  }

  // .text-enter-active {
  //   transition: all 1s ease;
  // }

  // .text-leave-active {
  //   transition: all .5s ease;
  // }

  // .text-enter {
  //   opacity: 0;
  //   transform: translateY(40px);
  // }

  // .text-leave-to {
  //   opacity: 0;
  // }

  // .text1-enter-active {
  //   transition: all 1s ease;
  // }

  // .text1-leave-active {
  //   transition: all .5s ease;
  // }

  // .text1-enter {
  //   opacity: 0;
  //   transform: translateY(-40px);
  // }

  // .text1-leave-to {
  //   opacity: 0;
  // }

  // .text2-enter-active {
  //   transition: all 1s ease;
  // }

  // .text2-leave-active {
  //   transition: all .5s ease;
  // }

  // .text2-enter {
  //   opacity: 0;
  //   transform: translateY(40px);
  // }

  // .text2-leave-to {
  //   opacity: 0;
  // }

  // @import './carousel-map.scss'
</style>

<script>
  import AutoSliderBar from '../auto-slider-bar/auto-slider-bar.vue'
  import { getIMCList } from 'Src/util/imc.js'
  import { teaInstanceInit } from 'Src/basic/boot/log-tea'
  const initParams = {
    app_id: 1192,
    media_type: 'img_text',
    media_id: 4015,
    business_id: 610
  }
  export default {
    data () {
      return {
        text: ['text', 'text1', 'text2', 'text3'],
        slideList: [],
        // 兜底图片
        defaultSlideListOld: [{
          img: 'https://lf3-beecdn.bytetos.com/obj/ies-fe-bee/bee_prod/biz_610/tos_5ba56949d4d1df6cf6799b4b691bf3ac.png',
          url: 'https://school.oceanengine.com/course/6840734861234274318'
        }, {
          img: 'https://lf3-beecdn.bytetos.com/obj/ies-fe-bee/bee_prod/biz_610/tos_9ebef2cdbd4a2ba13c21ea6aba1ef976.png',
          url: 'https://school.oceanengine.com/course/6840735310557478926'
        }],
        defaultSlideListNew: [{
          img: GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/e0476a438d864eafa325bbe5087f9501~tplv-yvqzo4lhg5-image.image'),
          url: 'https://school.oceanengine.com/course/6840734861234274318'
        }, {
          img: GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/2a6060336e8043409f01b42a5b451d3c~tplv-yvqzo4lhg5-image.image'),
          url: 'https://school.oceanengine.com/course/6840735310557478926'
        }, {
          img: GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/2d9a04a2f1b2479fb8da14d6bf687410~tplv-yvqzo4lhg5-image.image'),
          url: 'https://school.oceanengine.com/help?article_id=6810282075959066631'
        }, {
          img: GET_IMG_BYTE_SRC('tos-cn-i-yvqzo4lhg5/0df80556339e41ed908e7279809e7c7b~tplv-yvqzo4lhg5-image.image'),
          url: 'https://school.oceanengine.com/product_detail/?id=196&one=%E6%95%88%E6%9E%9C%E5%B9%BF%E5%91%8A&oneId=1&two=%E6%8A%96%E9%9F%B3%E7%AB%9E%E4%BB%B7&twoId=195&type=faq'
        }],
        curIndex: 0,
        isStop: false
      }
    },
    props: {
      isWhite: {
        type: Boolean
      }
    },
    components: {
      AutoSliderBar
    },
    mounted() {
      this.getIMCImageList()
    },
    methods: {
      sendBannerTeaEvent (eventName, params) {
        window.teaEvent(eventName, Object.assign(params, initParams))
      },
      changeImage (index) {
        this.sendBannerTeaEvent('imc_banner_show', { banner_id: this.slideList[index].id })
        this.curIndex = index
      },
      imageClick (index) {
        this.sendBannerTeaEvent('imc_banner_click', { banner_id: this.slideList[index].id })
        window.open(this.slideList[index].url)
      },
      stopCarousel () {
        this.isStop = true
      },
      ContinueCarousel () {
        this.isStop = false
      },
      getIMCImageList() {
        let _this = this
        BUI.fetch({
          url: _this.isWhite ?
            GET_IMC_SRC('obj/ies-fe-bee/bee_prod/biz_610/bee_prod_610_bee_publish_11530.json') :
            GET_IMC_SRC('obj/ies-fe-bee/bee_prod/biz_610/bee_prod_610_bee_publish_3424.json'),
          xhrFields: { withCredentials: false },
          beforeSend: xhr => {},
          success (resp) {
            if (!resp) {
              _this.slideList = this.isWhite ?  _this.defaultSlideListNew :  _this.defaultSlideListOld
              return
            }
            try {
              const res = getIMCList(resp)
              if (res.length) {
                _this.sendBannerTeaEvent('imc_banner_show', { banner_id: res[0].id })
              }
              _this.slideList = res.length ? res : _this.defaultSlideList
            } catch(e) {
              console.error(`获取登陆页banner图片异常: ${e}`)
              _this.slideList = _this.defaultSlideList
            }
          },
          error () {
            _this.slideList = _this.defaultSlideList
          }
        })
      }
    }
  }
  // export { default } from './carousel-map.js'
</script>
